import shiftRequestDetailsStore from "../../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_IS_DATA_READY', function setIsDataReadyInStore(isDataReady: boolean) {
    if (shiftRequestDetailsStore) {
        shiftRequestDetailsStore.isDataReady = isDataReady;
    }
});
